import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import taiChi4049Webp from '@/assets/landing-age-selection/tai-chi/40-49.webp'
import taiChi5059Webp from '@/assets/landing-age-selection/tai-chi/50-59.webp'
import taiChi6069Webp from '@/assets/landing-age-selection/tai-chi/60-69.webp'
import taiChi7080Webp from '@/assets/landing-age-selection/tai-chi/70-80.webp'
import alertGiftIcon from '@/assets/landing/alert-gift.png'

const schema: LandingScreenSchema = {
	order: ['LandingAlert', 'LandingTitleExtended', 'LandingAgeGrid'],

	components: {
		LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
			text: $t('female_yoga.pages.landing.alert_text'),
			icon: alertGiftIcon,
			backgroundColor: 'var(--Fill-Accent-16)',
			customStyles: {
				marginTop: 'var(--size-20)',
			},
		}),

		LandingTitleExtended: ({ $t }): LandingComponentsConfig['LandingTitleExtended'] => ({
			title: 'CHAIR Tai Chi<br/>for BEGINNERS',
			note: $t('female_yoga.pages.landing.quiz'),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'blue',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: taiChi4049Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: taiChi5059Webp,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: taiChi6069Webp,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: taiChi7080Webp,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
